class r {
  constructor() {
    this.decimalSeparator = ".";
  }
  zipcode(a) {
    return !!a.match(/^[AC-FHKNPRTV-Y][0-9][0-9W]\s[0-9AC-FHKNPRTV-Y]{4}$/i);
  }
}
export {
  r as default
};
